import { createElement as h } from "react"

import { Toolbar as MuiToolbar } from "@mui/material"
import { styled } from "@mui/styles"
import T from "prop-types"
import { and } from "ramda"

import { GUIElement } from "../../../lib/_public"

const StyledToolbar = styled(MuiToolbar)(({ color, shade, theme: { typography, withPalette } }) => {
  return {
    "& > .contentCenter": { justifyContent: "center" },
    "& > .contentEnd": { justifyContent: "flex-end" },
    "& > .contentStart": { justifyContent: "flex-start" },
    "& > .contentStart, & > .contentCenter, & > .contentEnd": { display: "flex", flex: "auto" },

    "&.MuiToolbar-root": {
      "& .MuiSvgIcon-root": { fontSize: typography.pxToRem(24) },
      "& button": { height: "44px" },
      "& button.Mui-disabled": { color: "#8E818c !important" },
      "& button:not(.rs_preserve)": { fontSize: typography.pxToRem(15) },
      "& span": { fontSize: typography.pxToRem(15) },

      backgroundColor: withPalette(color, shade),
      flexWrap: "wrap",
      gap: typography.pxToRem(32),
      justifyContent: "space-between",
      marginBottom: "20px",
      minHeight: typography.pxToRem(44),
      paddingLeft: 0,
      paddingRight: 0,
      width: "100%",
    },
  }
})

export const Toolbar = ({
  color = "common",
  contentCenter,
  contentEnd,
  contentStart,
  shade = "white",
}) =>
  h(
    StyledToolbar,
    {
      color,
      shade,
      className: "CirrusToolbar",
    },
    GUIElement.div({ className: "contentStart" }, contentStart),
    and(contentCenter, GUIElement.div({ className: "contentCenter" }, contentCenter)),
    GUIElement.div({ className: "contentEnd" }, contentEnd),
  )

Toolbar.propTypes = {
  color: T.string,
  contentCenter: T.node,
  contentEnd: T.node,
  contentStart: T.node,
  shade: T.string,
}
